import * as React from 'react';

import { Box, Card, CardContent, Typography } from '@mui/material';

import RawHtml from '../../legacy/components/base/RawHtml';
import ImageFluid from '../../legacy/components/base/ImageFluid';
import { CardItemProps } from './type';

// ********************************************************************************
export const CardItem: React.FC<CardItemProps> = (props) => {
  // == Render ====================================================================
  return (
    <Card sx={{ maxWidth: 560, p: '16px', width: '100%', boxShadow: 'none', border: 'none', mx: 'auto' }}>
      <Box borderRadius="12px" overflow="hidden">
        <ImageFluid
          fluid={props.backgroundImage}
          imgStyle={{ objectPosition: `${props.backgroundAlignment} center` }}
          alt={props.alt}
        />
      </Box>
      <CardContent>
        <Typography variant="h5" fontFamily="Gotham-Medium" fontSize="24px" color="primary">
          {props.title}
        </Typography>
        <Typography variant="body2" fontSize="16px" mt="1em">
          <RawHtml content={props.htmlDescription || props.description} />
        </Typography>
      </CardContent>
    </Card>
  );
};
